import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import logo from './logo.svg';
import './App.css';

import Home from './components/Home';
import Registration from './components/Registration'; // Import your new Registration component
import Saved from './components/Saved'; // Import your new Dashboard component
import Login from './components/Login'; // Import your new Login component
import ForgotPassword from './components/ForgotPassword'; // Import ForgotPassword component
import ResetPassword from './components/ResetPassword'; // Import ResetPassword component
import InitializeRecommendations from './components/InitializeRecommendations';
import Recommendations from './components/Recommendations';
import Search from './components/Search';
import { GuestPreviewProvider } from './context/GuestPreviewContext';
function App() {
  return (
    <Router>
      <GuestPreviewProvider>
        <div className="App">
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/register" element={<Registration />} /> {/* Add registration route */}
                <Route path="/login" element={<Login />} /> {/* Add Login route */}
                <Route path="/saved" element={<Saved />} /> {/* Add Dashboard route */}
                <Route path="/forgot-password" element={<ForgotPassword />} /> {/* Add Forgot Password route */}
                <Route path="/reset-password/:uidb64/:token" element={<ResetPassword />} /> {/* Add Reset Password route */}
                <Route path="/initialize-recommendations" element={<InitializeRecommendations />} />
                <Route path="/recommendations" element={<Recommendations />} />
                <Route path="/search" element={<Search />} />
            </Routes>
        </div>
      </GuestPreviewProvider>
    </Router>

  );
}

export default App;
